// Core
import { Injectable } from '@angular/core';
import { BreadcrumbService } from "libraries/service/breadcrumb/breadcrumb.service";

import { Yii } from "libraries/interfaces/Yii";

@Injectable()
export class BreadcrumbIqbaService extends BreadcrumbService {

    //Start State of breadcrumb
    public items: any = [
        // {
        //     "name": Yii.t('wui-iqba-js', 'Recherche d\'itinéraire'),
        //     "isActive": true,
        //     "isClickable": false,
        //     "action": {
        //         "name": "searchPage"
        //     },
        // }
    ];

    public pnrPage: any = {
        "name": Yii.t('wui-iqba-js', 'PNR'),
        "isActive": false,
        "isClickable": false,
        "action": {
            "name": "pnrPage"
        },
    };
    public provisionalItems: any= {
        "pnrPage": {
            "name": Yii.t('wui-iqba-js', 'PNR'),
        "isActive": false,
        "isClickable": false,
        "action": {
                "name": "pnrPage"
            }
        }
    };

    constructor(){
        super();
    }

    public initBreadcrumbIqba(): void {
        //Start State of breadcrumb
    this.items = [];

    this.pnrPage = {
            "name": Yii.t('wui-iqba-js', 'PNR'),
            "isActive": false,
            "isClickable": false,
            "action": {
                "name": "pnrPage"
            },
        };
    this.provisionalItems = {
            "pnrPage": {
                "name": Yii.t('wui-iqba-js', 'PNR'),
                "isActive": false,
                "isClickable": false,
                "action": {
                    "name": "pnrPage"
                }
            }
        };
    }

    public setProvisionalItems(provisionalItems: any){
        Object.assign(this.provisionalItems, provisionalItems);
    }
}
